﻿import {UIBase} from "./Tools/Base/UIBase";
import {Core} from "../Base/Core";
import {GameCategory, GameScreen} from "../enums";
import {Utils} from "../Utils/Utils";
import {NUtils} from "../Utils/NUtils";
import {UISprite} from "./Tools/Base/UISprite";
import {UIText} from "./Tools/Base/UIText";
import {UINineSlice} from "./Tools/Base/UINineSlice";
import {UINineSliceButton} from "./Tools/Base/UINineSliceButton";
import {UIAttention} from "./UIAttention";

export class UpgradeItem extends UIBase {
    get IsUnlocked() {
        return (
            (Core.Player.PlanetsSave.CurrentPlanet.collection.includes(this.upgradeData.unlockCreatureId) ||
                (Core.Player.PlanetsSave.currentPlanetId > 1 && this.upgradeData.upgradeType == UpgradeType.BubbleTime))
        );
    }

    Awake() {
        super.Awake();

        this.onClickPurchase = this.onClickPurchase.bind(this);

        this.back = this.addChild(new UINineSlice("bg-rounding-28px"));
        this.back.tint = 0x000000;
        this.back.alpha = 0.5;

        this.iconImage = this.addChild(new UISprite());
        this.softBtn = this.addChild(
            new UINineSliceButton("btn-orange", {
                label: "0",
                icon: "ico-gold",
                iconSize: 1,
            })
        );
        this.hardBtn = this.addChild(
            new UINineSliceButton("btn-blue", {
                label: "0",
                icon: "ico-diamond",
                iconSize: 1,
            })
        );

        this.upgradeType = null; // UpgradeType
        this.attention = this.addChild(new UIAttention());

        this.buttonDisabler = null; // PurchaseButtonDisabler
        this.nameField = this.addChild(new UIText(""));
        this.progressField = this.addChild(new UIText("", { fill: 0x00ff00, fontSize: 32 }));
        this.descriptionField = this.addChild(new UIText("", { fill: 0x82c3d0, align: "left", fontSize: 32, wordWrap: true }));
        this.upgradeData = null; // UpgradeData
    }

    Init(upgradeType) {
        this.upgradeType = upgradeType;
        this.upgradeData = Core.GameData.Upgrades.UpgradeByType(this.upgradeType);

        switch (this.upgradeType) {
            case UpgradeType.BubbleTime: // 0
                this.iconImage.setImage("upgrades/bubletime-ico");
                this.nameField.text = Core.Localizator.Get("upgrade_bubletime_title");
                this.descriptionField.text = Core.Localizator.Get("upgrade_bubletime_description");
                break;

            case UpgradeType.MoneyBox: // 1
                this.iconImage.setImage("upgrades/kopilka-ico");
                this.nameField.text = Core.Localizator.Get("upgrade_moneybox_title");
                this.descriptionField.text = Core.Localizator.Get("upgrade_moneybox_description");
                break;

            case UpgradeType.BubbleCreature: // 4
                this.iconImage.setImage("upgrades/monsterinbubble-ico");
                this.nameField.text = Core.Localizator.Get("upgrade_bubblemonster_title");
                this.descriptionField.text = Core.Localizator.Get("upgrade_bubblemonster_description");
                break;

            default:
                this.SetActive(false);
                break;
        }

        this.softBtn.on("pointertap", this.onClickPurchase);
        this.hardBtn.on("pointertap", this.onClickPurchase);
    }

    fitLayout(rect) {
        this.position.copyFrom(rect);
        this.back.width = rect.width;
        this.back.height = rect.height;

        let backRect = new PIXI.Rectangle(this.back.x, this.back.y, this.back.width, this.back.height);

        rect = backRect.clone();
        rect.width = backRect.width * 0.23;
        rect.height = backRect.height * 0.8;
        rect.x = (backRect.width - rect.width) * 0;
        rect.y = (backRect.height - rect.height) * 0.5;
        this.iconImage.fitRect(rect);

        rect = backRect.clone();
        rect.width = backRect.width * 0.46;
        rect.height = backRect.height * 0.27;
        rect.x = (backRect.width - rect.width) * 0.45;
        rect.y = (backRect.height - rect.height) * 0.13;
        this.nameField.anchor.set(0, 0.5);
        this.nameField.fitLayout(rect);

        rect.height = backRect.height * 0.22;
        rect.y = (backRect.height - rect.height) * 0.43;
        this.progressField.anchor.set(0, 0.5);
        this.progressField.fitLayout(rect);

        rect.height = backRect.height * 0.37;
        rect.y = (backRect.height - rect.height) * 0.84;
        this.descriptionField.anchor.set(0, 0.5);
        this.descriptionField.fitLayout(rect);

        rect = backRect.clone();
        rect.width = backRect.width * 0.25;
        rect.height = backRect.height * 0.5;
        rect.x = (backRect.width - rect.width) * 0.95;
        rect.y = (backRect.height - rect.height) * 0.5;
        this.softBtn.fitLayout(rect);
        this.hardBtn.fitLayout(rect);

        let contentRect = new PIXI.Rectangle(0, 0, rect.width, rect.height).pad(-rect.width * 0.1, -rect.height * 0.25);
        this.softBtn.content.fitLayout(contentRect);
        this.hardBtn.content.fitLayout(contentRect);
    }

    onClickPurchase() {
        let currentProgress = Core.Player.PlanetsSave.GetUpgradeProgress(this.upgradeType);
        let hasNextUpgrade = this.upgradeData.steps.length > currentProgress.upgradeIndex + 1;
        let nextUpgrade = hasNextUpgrade ? this.upgradeData.steps[currentProgress.upgradeIndex + 1] : null;

        if (nextUpgrade) {
            if (Core.Player.SpendMoney(nextUpgrade.GetPrice(), GameCategory.upgrade, GameScreen.upgrades, this.upgradeData.upgradeType)) {
                Core.Player.PlanetsSave.Upgrade(this.upgradeType);
                this.UpdateUI();
                Core.Audio.Play("Upgrade");
            } else {
                switch (nextUpgrade.GetPrice().priceType) {
                    case MoneyType.Soft:
                        Core.UI.SetState(UIState.BankSoft);
                        break;

                    case MoneyType.Hard:
                        Core.UI.SetState(UIState.BankHard);
                        break;

                    default:
                        break;
                }
            }
        }
    }

    UpdateUI() {
        this.SetActive(this.IsUnlocked);
        if (!this.Active) return;

        let currentProgress = Core.Player.PlanetsSave.GetUpgradeProgress(this.upgradeType);
        let hasNextUpgrade = this.upgradeData.steps.length > currentProgress.upgradeIndex + 1;
        let nextUpgrade = hasNextUpgrade ? this.upgradeData.steps[currentProgress.upgradeIndex + 1] : null;
        let nextUpgradePrice = nextUpgrade == null ? null : nextUpgrade.GetPrice();
        let isSoftPrice = hasNextUpgrade && nextUpgradePrice.priceType == MoneyType.Soft;
        let isHardPrice = hasNextUpgrade && nextUpgradePrice.priceType == MoneyType.Hard;

        console.log("UPGRADE", this.upgradeType, nextUpgradePrice);

        this.softBtn.SetActive(isSoftPrice);
        this.hardBtn.SetActive(isHardPrice);

        this.softBtn.label = isSoftPrice ? NUtils.FormatMoney(nextUpgradePrice.priceValue) : "";
        this.hardBtn.label = isHardPrice ? NUtils.FormatMoney(nextUpgradePrice.priceValue) : "";

        // this.buttonDisabler.SetPrice(nextUpgradePrice);

        let totalValue = this.upgradeData.TotalValue(currentProgress.upgradeIndex);
        let nextValue = hasNextUpgrade ? this.upgradeData.TotalValue(currentProgress.upgradeIndex + 1) : 0;

        if (this.upgradeType == UpgradeType.MoneyBox && currentProgress.upgradeIndex == 0) {
            this.progressField.text = Core.Localizator.Get("not_purchased");
        } else if (this.upgradeType == UpgradeType.MoneyBox) {
            let from = ~~(totalValue / 60 / 60);
            let to = ~~(nextValue / 60 / 60);
            this.progressField.text = hasNextUpgrade ? Utils.Format("{0}h => {1}h", from, to) : Utils.Format("{0}h", from);
        } else {
            this.progressField.text = hasNextUpgrade ? Utils.Format("{0} => {1}", totalValue, nextValue) : totalValue;
        }
    }
}
